import React, { Component } from 'react';
import VariableRow from './VariableRow';
import '../App.css';
import results from '../data.json';

class Grid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resultGroups: [],
    };
  }

  render() {
    const numResults = results.length;
    console.log(numResults);

    let groupCount = 0;

    for (let i = 0; i < numResults;) {
      // divide results into groups of 2 or 3 as appropriate
      const columnObject = {
        cards: [],
      };

      columnObject.is_left = ((groupCount + 1) % 4 === 1);
      const isThreeGroup = !(((groupCount + 1) % 4 === 1 || (groupCount + 1) % 4 === 0));

      if (isThreeGroup) {
        // push three objects
        columnObject.is_small = true;
        columnObject.cards.push(results[i]);
        columnObject.cards.push(results[i + 1]);
        columnObject.cards.push(results[i + 2]);
        this.state.resultGroups.push(columnObject);
        groupCount += 1;
        i += 3;
        continue;
      }

      columnObject.is_small = false;
      columnObject.cards.push(results[i]);
      columnObject.cards.push(results[i + 1]);
      groupCount += 1;
      this.state.resultGroups.push(columnObject);
      i += 2;
    }

    console.log(this.state.resultGroups);
    this.state.resultGroups[11].cards[0] = JSON.parse(JSON.stringify(this.state.resultGroups[10].cards[2]));
    this.state.resultGroups[11].cards[1] = JSON.parse(JSON.stringify(this.state.resultGroups[9].cards[2]));
    // this.state.resultGroups[8].cards[1].hide = true;
    this.state.resultGroups[9].cards[2].hide = true;
    this.state.resultGroups[10].cards[2].hide = true;
    return (
      <div className="container grid">
        <div className="row">
          {this.state.resultGroups.map((item) => {
            return (
              <VariableRow
                cards={item.cards}
                small_card={item.is_small}
                is_left_row={item.is_left}
              />
            );
          })}
        </div>
      </div>
    );
  }
}


export default Grid;
